var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudsRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1920 170.9",
    style: {
      enableBackground: "new 0 0 1920 170.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF5A60;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1920,170.9c0,0,0-112.2-115.4-96.7c-1-35.5-44.6-69.1-83.9-69.1s-73,22.5-85.1,60.4 c-21.2-19.6-84.4-23.9-114,19.5c-1.8-6.6-40.6-23-62.9,1.7c-9.7-35.7-97.6-105-192.5-37.7c-7.6-17.4-45-42.4-69.3-47.1 c-24.3-4.7-118.2-7.7-134.6,99.8c-14.1-40.2-77.6-61.9-120-36C928.8,25.7,846.8-2.6,802,50.6C785.9,19.9,735,0.4,687.8,18 c-39.6,14.7-51.2,60.1-51.2,60.1S533.9,32.3,488.8,125c-17.2-20-52.7-36.9-97.4-16.5c-1.9-88.2-167.9-141.6-228.8-18.1 c-18.6-14.1-43.2-12.9-58.9,0.9C103.1,63.6,55.2,23.3,0,39.6c0,130.9,0,131.3,0,131.3H1920z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudsRed);
export default __webpack_public_path__ + "static/media/cloudsRed.ebc5ee33f84d7033e7ede4eac3f4a78d.svg";
export { ForwardRef as ReactComponent };